
// @codekit-prepend "jquery.cycle2/jquery.cycle2.js" quiet;
// @codekit-prepend "jquery.cycle2/jquery.cycle2.autoheight.js" quiet;
// @codekit-prepend "jquery.cycle2/jquery.cycle2.caption.js" quiet;
// @codekit-prepend "jquery.cycle2/jquery.cycle2.hash.js" quiet;
// @codekit-prepend "jquery.cycle2/jquery.cycle2.loader.js" quiet;

// @codekit-prepend "jquery.cycle2/jquery.cycle2.progressive.js" quiet;
// @codekit-prepend "jquery.cycle2/jquery.cycle2.tmpl.js" quiet;
// @codekit-prepend "jquery.cycle2/jquery.cycle2.swipe.js" quiet;
// @codekit-prepend "jquery.cycle2/jquery.cycle2.carousel.js" quiet;

// @codekit-prepend "jquery-visible/jquery.visible.js" quiet;



// @codekit-prepend "../../../../../../node_modules/css-scroll-snap-polyfill/dist/css-scroll-snap-polyfill.umd.js";
// @codekit-prepend "../../../../../../node_modules/jquery-easing/jquery.easing.1.3.js";